import { Refresh } from '@mui/icons-material';
import { Alert, Button, Snackbar } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { reloadForNewVersion, startVersionCheck } from '../../utils/versionCheck';

/**
 * Component that checks for new versions and notifies the user
 */
const VersionUpdateNotification: React.FC = () => {
  const [newVersion, setNewVersion] = useState<string | null>(null);
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    // Start version checking
    const cleanup = startVersionCheck(latestVersion => {
      setNewVersion(latestVersion);
      setShowNotification(true);
    });

    // Cleanup on unmount
    return cleanup;
  }, []);

  const handleReload = () => {
    setShowNotification(false);
    reloadForNewVersion();
  };

  const handleDismiss = () => {
    setShowNotification(false);
  };

  return (
    <Snackbar
      open={showNotification}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      onClose={handleDismiss}
      sx={{ mt: 8 }}
    >
      <Alert
        severity="info"
        variant="filled"
        onClose={handleDismiss}
        action={
          <Button color="inherit" size="small" onClick={handleReload} startIcon={<Refresh />}>
            Reload
          </Button>
        }
        sx={{
          alignItems: 'center',
        }}
      >
        A new version ({newVersion}) is available. Reload to update.
      </Alert>
    </Snackbar>
  );
};

export default VersionUpdateNotification;
